import { unitId, actionId } from '@/annotations'
import { ModalHeader, ModalBody, ModalFooter } from '@/components/Modal'
import { Modal } from '@/screens/shared/ModalScrim'
import { Button } from '@/components/Button'
import { Alert } from '@/components/Alert'
import { M_RUNOK_COPY } from '@/copy/modals'
import type { components } from '@/api/generated/schema'

type JobRef = components['schemas']['JobRef']

/**
 * `m-runok` — process/09-SCREEN-SPECS/m-runok.md. The success outcome of `restoreTrigger`
 * (§9.h A1–A2: "**this modal IS that call's success outcome**" — nothing here calls it; the
 * caller — the restore wizard's order pane, Pass 6, not built yet — opens this modal with the
 * `JobRef` `restoreTrigger` already returned). It says the restore has **started**, never that it
 * has succeeded (rule 2).
 */
export function MRunok({
  job,
  notifyEmail,
  onDismiss,
  onOpenJob,
}: {
  job: JobRef
  notifyEmail: string
  onDismiss: () => void
  onOpenJob: () => void
}) {
  const headingId = 'm-runok-heading'
  return (
    <Modal dataScr={unitId('m-runok')} labelledBy={headingId} onDismiss={onDismiss} maxWidth={440}>
      <ModalHeader id={headingId} heading={M_RUNOK_COPY.heading}>
        {M_RUNOK_COPY.jobRunningTemplate(job.handle)}
      </ModalHeader>
      <ModalBody>
        <Alert variant="info">{M_RUNOK_COPY.emailNoteTemplate(notifyEmail)}</Alert>
      </ModalBody>
      <ModalFooter>
        <Button data-act={undefined} ghost onClick={onDismiss}>
          {M_RUNOK_COPY.stayButton}
        </Button>
        <Button
          data-act={actionId('nav.v-restorejob')}
          onClick={() => {
            onOpenJob()
            onDismiss()
          }}
        >
          {M_RUNOK_COPY.openJobButton}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
